export type FooterItem =
  | { id: string; label: string; href: string; external?: boolean; visibility?: 'mobile' | 'desktop' }
  | { id: string; label: string; destination: 'studio'; visibility?: 'mobile' | 'desktop' };

export interface FooterGroup {
  id: string;
  label: string;
  items: readonly FooterItem[];
}

export const contactLinks = [
  { id: 'support', label: 'Support', href: 'mailto:support@getcartwheel.com', external: true },
  { id: 'discord', label: 'Discord', href: 'https://discord.gg/QGRBqwJakb', external: true },
  { id: 'linkedin', label: 'LinkedIn', href: 'https://linkedin.com/company/getcartwheel', external: true },
  { id: 'instagram', label: 'Instagram', href: 'https://instagram.com/getcartwheel', external: true },
  { id: 'tiktok', label: 'TikTok', href: 'https://tiktok.com/@getcartwheel', external: true },
] as const satisfies readonly FooterItem[];

export const footerGroups = [
  {
    id: 'models', label: 'Models', items: [
      { id: 'comic', label: 'Comic', href: '/model/comic' },
      { id: 'swing', label: 'Swing', href: '/model/swing' },
    ]
  },
  {
    id: 'apps', label: 'Apps', items: [
      { id: 'motion-capture', label: 'Performance Capture', href: '/product/performance-capture' },
      { id: 'motion-generator', label: 'Performance Generation', href: '/product/performance-generation' },
      { id: 'motion-editor', label: 'Performance Editor', href: '/product/performance-editor' },
      { id: 'character-generator', label: 'Character Generator', destination: 'studio' },
      { id: 'canvas', label: 'Canvas', destination: 'studio' },
      { id: 'pricing', label: 'Pricing', href: '/pricing' },
    ]
  },
  {
    id: 'pipeline-tools', label: 'Pipeline Tools', items: [
      { id: 'cartographer', label: 'Cartographer', href: '/product/cartographer' },
      { id: 'mcp', label: 'MCP', href: 'https://github.com/Cartwhl/cartwheel-mcp', external: true },
      { id: 'api', label: 'API', href: 'https://api-docs.getcartwheel.com/', external: true },
      { id: 'plugins', label: 'Plugins', href: '/plugins' },
    ]
  },
  {
    id: 'research', label: 'Research', items: [
      { id: 'scaling-laws-paper', label: 'Scaling Laws', href: 'https://github.com/cartwhl/scaling-laws-for-motion', external: true },
      { id: 'blog', label: 'Blog', href: '/blog' },
    ]
  },
  {
    id: 'company', label: 'Company', items: [
      { id: 'about', label: 'About Us', href: '/company' },
      { id: 'contact', label: 'Contact', href: '/contact' },
      { id: 'api-docs', label: 'API Docs', href: 'https://api-docs.getcartwheel.com/', external: true },
      { id: 'canvas-docs', label: 'Canvas Docs', href: 'https://docs.getcartwheel.com/docs/getting-started/introduction', external: true, visibility: 'desktop' },
      { id: 'mcp-docs', label: 'MCP Docs', href: 'https://github.com/Cartwhl/cartwheel-mcp', external: true, visibility: 'mobile' },
    ]
  },
  {
    id: 'contact', label: 'Contact us', items: contactLinks,
  },
] as const satisfies readonly FooterGroup[];

export const legalLinks = [
  { id: 'privacy', label: 'Privacy policy', href: '/privacy-policy' },
  { id: 'terms', label: 'Terms', href: '/terms-of-use' },
] as const satisfies readonly FooterItem[];
